import type { SxProps, Theme } from '@mui/material/styles'

/** Shared Close CTA for Library tab modals (Built-in Instruments, templates, Question Bank). */
export const libraryModalCloseButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  borderRadius: '8px',
  bgcolor: '#008cd0',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': { bgcolor: '#0076b0', boxShadow: 'none' },
}
